import Home from "../components/pages/wishlist/Home.vue";

export const wishlist_route = {
  path: "/wishlist/review",
  name: "wishlist_review",
  component: Home,
  children: [],
};
